import { Component, Input, Output, EventEmitter, NgZone } from "@angular/core";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { UserService } from "../../user.service";
import { Subject, Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LoaderService } from "../../../services/loader/loader.service";
import { HttpClient } from "@angular/common/http";
import { KeystoneHttpClient } from "../../../../keystone-http";
import {NavController} from "ionic-angular";

@Component({
  selector: "ute-sms-drawer",
  templateUrl: "ute-sms-drawer.component.html"
})
export class UteSmsDrawer {
  @Input() isSmsDrawerOpen: boolean;
  @Input() cancel: boolean = false;
  @Input() cancelLabel: string;
  @Input() action: string;
  @Input() actionLabel: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() phoneNumber: string;

  @Input() titleLabel: string;
  @Input() boxTitleLabel: string;
  @Input() boxSubtitleLabel: string;
  @Input() buttonLabel: string;

  @Output() isSmsDrawerOpenChange = new EventEmitter();
  @Output() onClickAction = new EventEmitter();
  // @Output() onChangePrivacy = new EventEmitter;
  @Output() confirmOpen = new EventEmitter();

  public privacyValid: boolean;
  public privacyItems: any;
  public user: any;

  private unsubscribe: Subject<void> = new Subject<void>();
  public isLoading$: Observable<boolean>;

  verificationForm: any;
  code = "";
  isValidCode: boolean = true;
  isInsertCode: boolean = false;
  error: boolean = false;

  constructor(
    public navCtrl: NavController,
    private userService: UserService,
    private authService: AuthenticationService,
    public loader: LoaderService,
    private http: HttpClient,
    private authHttp: KeystoneHttpClient,
    public zone: NgZone
  ) {
    // this.currentUser$ = this.userService.currentUser$;
    this.user = this.userService.currentUser$;
    this.verificationForm = new FormGroup({
      code: new FormControl(this.code, {
        validators: [Validators.required]
      })
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  onChangeDrawer(event) {
    this.isSmsDrawerOpenChange.emit(false);
  }

  onSubmitAction(event) {
    this.onClickAction.emit(event);
  }

  checkInsertCode(condition) {
    this.zone.run(() => {
      // this.isInsertCode = this.code && this.code.length < 4;
      this.isInsertCode = condition;
    });
  }

  changeCodeValue() {}

  sendSms() {
    this.authService.recoverPassword(this.phoneNumber);
  }

  checkCode() {
    if (this.code && this.code.length < 4) {
      this.verificationForm.controls["code"].setErrors({ incorrect: true });
      this.isValidCode = false;
    } else {
      if (this.phoneNumber) {
        if (this.action === "registration") {
          //this.loader.activeLoader();
          this.authService.checkVerificationCode(this.code);
          this.user.pipe(takeUntil(this.unsubscribe)).subscribe(
            user => {
              if (user) {
                //this.loader.stopLoader();
                if (
                  (user && user.activeRoute === "verified") ||
                  (user && user.activeRoute === "registered") ||
                  (user && user.activeRoute === "associated") ||
                  (user && user.activeRoute === "completed")
                ) {
                  this.confirmOpen.emit(true);
                  this.isValidCode = true;
                }
              }
            },
            () => {
              this.error = true;
            }
          );
        }
        if (this.action === "recover-password") {
          this.loader.activeLoader();
          this.authService.checkVerificationPasswordCode(
            this.code,
            this.phoneNumber
          );
          this.user.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
            this.loader.stopLoader();
            if (user) {
              if (
                (user && user.activeRoute === "registered") ||
                (user && user.activeRoute === "associated") ||
                (user && user.activeRoute === "completed")
              ) {
                this.isValidCode = true;
                this.confirmOpen.emit(true);
              } else {
                this.error = true;
              }
            }
          });
        }
      } else {
        this.authService.checkVerificationCode(this.code);
        this.isValidCode = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/user/components/ute-sms-drawer/ute-sms-drawer.component.ts